
export interface SingleShardRestoreSetting {
    shardNumber: number;
    nodeTag: string;
    folderName: string;
    lastFileNameToRestore: string;
}